function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _createForOfIteratorHelper(o) { if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (o = _unsupportedIterableToArray(o))) { var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e19) { throw _e19; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var it, normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e20) { didErr = true; err = _e20; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var e = "colors",
    t = "sizes",
    r = "space",
    n = {
  gap: r,
  gridGap: r,
  columnGap: r,
  gridColumnGap: r,
  rowGap: r,
  gridRowGap: r,
  inset: r,
  insetBlock: r,
  insetBlockEnd: r,
  insetBlockStart: r,
  insetInline: r,
  insetInlineEnd: r,
  insetInlineStart: r,
  margin: r,
  marginTop: r,
  marginRight: r,
  marginBottom: r,
  marginLeft: r,
  marginBlock: r,
  marginBlockEnd: r,
  marginBlockStart: r,
  marginInline: r,
  marginInlineEnd: r,
  marginInlineStart: r,
  padding: r,
  paddingTop: r,
  paddingRight: r,
  paddingBottom: r,
  paddingLeft: r,
  paddingBlock: r,
  paddingBlockEnd: r,
  paddingBlockStart: r,
  paddingInline: r,
  paddingInlineEnd: r,
  paddingInlineStart: r,
  top: r,
  right: r,
  bottom: r,
  left: r,
  scrollMargin: r,
  scrollMarginTop: r,
  scrollMarginRight: r,
  scrollMarginBottom: r,
  scrollMarginLeft: r,
  scrollMarginX: r,
  scrollMarginY: r,
  scrollMarginBlock: r,
  scrollMarginBlockEnd: r,
  scrollMarginBlockStart: r,
  scrollMarginInline: r,
  scrollMarginInlineEnd: r,
  scrollMarginInlineStart: r,
  scrollPadding: r,
  scrollPaddingTop: r,
  scrollPaddingRight: r,
  scrollPaddingBottom: r,
  scrollPaddingLeft: r,
  scrollPaddingX: r,
  scrollPaddingY: r,
  scrollPaddingBlock: r,
  scrollPaddingBlockEnd: r,
  scrollPaddingBlockStart: r,
  scrollPaddingInline: r,
  scrollPaddingInlineEnd: r,
  scrollPaddingInlineStart: r,
  fontSize: "fontSizes",
  background: e,
  backgroundColor: e,
  backgroundImage: e,
  borderImage: e,
  border: e,
  borderBlock: e,
  borderBlockEnd: e,
  borderBlockStart: e,
  borderBottom: e,
  borderBottomColor: e,
  borderColor: e,
  borderInline: e,
  borderInlineEnd: e,
  borderInlineStart: e,
  borderLeft: e,
  borderLeftColor: e,
  borderRight: e,
  borderRightColor: e,
  borderTop: e,
  borderTopColor: e,
  caretColor: e,
  color: e,
  columnRuleColor: e,
  fill: e,
  outline: e,
  outlineColor: e,
  stroke: e,
  textDecorationColor: e,
  fontFamily: "fonts",
  fontWeight: "fontWeights",
  lineHeight: "lineHeights",
  letterSpacing: "letterSpacings",
  blockSize: t,
  minBlockSize: t,
  maxBlockSize: t,
  inlineSize: t,
  minInlineSize: t,
  maxInlineSize: t,
  width: t,
  minWidth: t,
  maxWidth: t,
  height: t,
  minHeight: t,
  maxHeight: t,
  flexBasis: t,
  gridTemplateColumns: t,
  gridTemplateRows: t,
  borderWidth: "borderWidths",
  borderTopWidth: "borderWidths",
  borderRightWidth: "borderWidths",
  borderBottomWidth: "borderWidths",
  borderLeftWidth: "borderWidths",
  borderStyle: "borderStyles",
  borderTopStyle: "borderStyles",
  borderRightStyle: "borderStyles",
  borderBottomStyle: "borderStyles",
  borderLeftStyle: "borderStyles",
  borderRadius: "radii",
  borderTopLeftRadius: "radii",
  borderTopRightRadius: "radii",
  borderBottomRightRadius: "radii",
  borderBottomLeftRadius: "radii",
  boxShadow: "shadows",
  textShadow: "shadows",
  transition: "transitions",
  zIndex: "zIndices"
},
    i = function i(e, t) {
  return "function" == typeof t ? {
    "()": Function.prototype.toString.call(t)
  } : t;
},
    o = function o() {
  var e = Object.create(null);
  return function (t, r) {
    var o = function (e) {
      return JSON.stringify(e, i);
    }(t);

    for (var _len = arguments.length, n = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
      n[_key - 2] = arguments[_key];
    }

    return o in e ? e[o] : e[o] = r.apply(void 0, [t].concat(n));
  };
},
    l = Symbol.for("sxs.internal"),
    s = function s(e, t) {
  return Object.defineProperties(e, Object.getOwnPropertyDescriptors(t));
},
    a = function a(e) {
  for (var _t in e) {
    return !0;
  }

  return !1;
},
    c = Object.prototype.hasOwnProperty,
    d = function d(e) {
  return e.includes("-") ? e : e.replace(/[A-Z]/g, function (e) {
    return "-" + e.toLowerCase();
  });
},
    g = /\s+(?![^()]*\))/,
    p = function p(e) {
  return function (t) {
    return e.apply(void 0, _toConsumableArray("string" == typeof t ? String(t).split(g) : [t]));
  };
},
    u = {
  appearance: function appearance(e) {
    return {
      WebkitAppearance: e,
      appearance: e
    };
  },
  backfaceVisibility: function backfaceVisibility(e) {
    return {
      WebkitBackfaceVisibility: e,
      backfaceVisibility: e
    };
  },
  backdropFilter: function backdropFilter(e) {
    return {
      WebkitBackdropFilter: e,
      backdropFilter: e
    };
  },
  backgroundClip: function backgroundClip(e) {
    return {
      WebkitBackgroundClip: e,
      backgroundClip: e
    };
  },
  boxDecorationBreak: function boxDecorationBreak(e) {
    return {
      WebkitBoxDecorationBreak: e,
      boxDecorationBreak: e
    };
  },
  clipPath: function clipPath(e) {
    return {
      WebkitClipPath: e,
      clipPath: e
    };
  },
  content: function content(e) {
    return {
      content: e.includes('"') || e.includes("'") || /^([A-Za-z]+\([^]*|[^]*-quote|inherit|initial|none|normal|revert|unset)$/.test(e) ? e : "\"".concat(e, "\"")
    };
  },
  hyphens: function hyphens(e) {
    return {
      WebkitHyphens: e,
      hyphens: e
    };
  },
  maskImage: function maskImage(e) {
    return {
      WebkitMaskImage: e,
      maskImage: e
    };
  },
  maskSize: function maskSize(e) {
    return {
      WebkitMaskSize: e,
      maskSize: e
    };
  },
  tabSize: function tabSize(e) {
    return {
      MozTabSize: e,
      tabSize: e
    };
  },
  textSizeAdjust: function textSizeAdjust(e) {
    return {
      WebkitTextSizeAdjust: e,
      textSizeAdjust: e
    };
  },
  userSelect: function userSelect(e) {
    return {
      WebkitUserSelect: e,
      userSelect: e
    };
  },
  marginBlock: p(function (e, t) {
    return {
      marginBlockStart: e,
      marginBlockEnd: t || e
    };
  }),
  marginInline: p(function (e, t) {
    return {
      marginInlineStart: e,
      marginInlineEnd: t || e
    };
  }),
  maxSize: p(function (e, t) {
    return {
      maxBlockSize: e,
      maxInlineSize: t || e
    };
  }),
  minSize: p(function (e, t) {
    return {
      minBlockSize: e,
      minInlineSize: t || e
    };
  }),
  paddingBlock: p(function (e, t) {
    return {
      paddingBlockStart: e,
      paddingBlockEnd: t || e
    };
  }),
  paddingInline: p(function (e, t) {
    return {
      paddingInlineStart: e,
      paddingInlineEnd: t || e
    };
  })
},
    h = /([\d.]+)([^]*)/,
    f = function f(e, t) {
  return e.length ? e.reduce(function (e, r) {
    return e.push.apply(e, _toConsumableArray(t.map(function (e) {
      return e.includes("&") ? e.replace(/&/g, /[ +>|~]/.test(r) && /&.*&/.test(e) ? ":is(".concat(r, ")") : r) : r + " " + e;
    }))), e;
  }, []) : t;
},
    m = function m(e, t) {
  return e in b && "string" == typeof t ? t.replace(/^((?:[^]*[^\w-])?)(fit-content|stretch)((?:[^\w-][^]*)?)$/, function (t, r, n, i) {
    return r + ("stretch" === n ? "-moz-available".concat(i, ";").concat(d(e), ":").concat(r, "-webkit-fill-available") : "-moz-fit-content".concat(i, ";").concat(d(e), ":").concat(r, "fit-content")) + i;
  }) : String(t);
},
    b = {
  blockSize: 1,
  height: 1,
  inlineSize: 1,
  maxBlockSize: 1,
  maxHeight: 1,
  maxInlineSize: 1,
  maxWidth: 1,
  minBlockSize: 1,
  minHeight: 1,
  minInlineSize: 1,
  minWidth: 1,
  width: 1
},
    S = function S(e) {
  return e ? e + "-" : "";
},
    k = function k(e, t, r) {
  return e.replace(/([+-])?((?:\d+(?:\.\d*)?|\.\d+)(?:[Ee][+-]?\d+)?)?(\$|--)([$\w-]+)/g, function (e, n, i, o, l) {
    return "$" == o == !!i ? e : (n || "--" == o ? "calc(" : "") + "var(--" + ("$" === o ? S(t) + (l.includes("$") ? "" : S(r)) + l.replace(/\$/g, "-") : l) + ")" + (n || "--" == o ? "*" + (n || "") + (i || "1") + ")" : "");
  });
},
    y = /\s*,\s*(?![^()]*\))/,
    B = Object.prototype.toString,
    $ = function $(e, t, r, n, i) {
  var o, l, s;

  var a = function a(e, t, r) {
    var c, g;

    var p = function p(e) {
      for (c in e) {
        var _R = 64 === c.charCodeAt(0),
            _z = _R && Array.isArray(e[c]) ? e[c] : [e[c]];

        var _iterator = _createForOfIteratorHelper(_z),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            g = _step.value;

            var _e = /[A-Z]/.test($ = c) ? $ : $.replace(/-[^]/g, function (e) {
              return e[1].toUpperCase();
            }),
                _z2 = "object" == _typeof(g) && g && g.toString === B && (!n.utils[_e] || !t.length);

            if (_e in n.utils && !_z2) {
              var _t2 = n.utils[_e];

              if (_t2 !== l) {
                l = _t2, p(_t2(g)), l = null;
                continue;
              }
            } else if (_e in u) {
              var _t3 = u[_e];

              if (_t3 !== s) {
                s = _t3, p(_t3(g)), s = null;
                continue;
              }
            }

            if (_R && (b = c.slice(1) in n.media ? "@media " + n.media[c.slice(1)] : c, c = b.replace(/\(\s*([\w-]+)\s*(=|<|<=|>|>=)\s*([\w-]+)\s*(?:(<|<=|>|>=)\s*([\w-]+)\s*)?\)/g, function (e, t, r, n, i, o) {
              var l = h.test(t),
                  s = .0625 * (l ? -1 : 1),
                  _ref = l ? [n, t] : [t, n],
                  _ref2 = _slicedToArray(_ref, 2),
                  a = _ref2[0],
                  c = _ref2[1];

              return "(" + ("=" === r[0] ? "" : ">" === r[0] === l ? "max-" : "min-") + a + ":" + ("=" !== r[0] && 1 === r.length ? c.replace(h, function (e, t, n) {
                return Number(t) + s * (">" === r ? 1 : -1) + n;
              }) : c) + (i ? ") and (" + (">" === i[0] ? "min-" : "max-") + a + ":" + (1 === i.length ? o.replace(h, function (e, t, r) {
                return Number(t) + s * (">" === i ? -1 : 1) + r;
              }) : o) : "") + ")";
            })), _z2) {
              var _e2 = _R ? r.concat(c) : _toConsumableArray(r),
                  _n2 = _R ? _toConsumableArray(t) : f(t, c.split(y));

              void 0 !== o && i(x.apply(void 0, _toConsumableArray(o))), o = void 0, a(g, _n2, _e2);
            } else void 0 === o && (o = [[], t, r]), c = _R || 36 !== c.charCodeAt(0) ? c : "--".concat(S(n.prefix)).concat(c.slice(1).replace(/\$/g, "-")), g = _z2 ? g : "number" == typeof g ? g && _e in I ? String(g) + "px" : String(g) : k(m(_e, null == g ? "" : g), n.prefix, n.themeMap[_e]), o[0].push("".concat(_R ? "".concat(c, " ") : "".concat(d(c), ":")).concat(g));
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      }

      var b, $;
    };

    p(e), void 0 !== o && i(x.apply(void 0, _toConsumableArray(o))), o = void 0;
  };

  a(e, t, r);
},
    x = function x(e, t, r) {
  return "".concat(r.map(function (e) {
    return "".concat(e, "{");
  }).join("")).concat(t.length ? "".concat(t.join(","), "{") : "").concat(e.join(";")).concat(t.length ? "}" : "").concat(Array(r.length ? r.length + 1 : 0).join("}"));
},
    I = {
  animationDelay: 1,
  animationDuration: 1,
  backgroundSize: 1,
  blockSize: 1,
  border: 1,
  borderBlock: 1,
  borderBlockEnd: 1,
  borderBlockEndWidth: 1,
  borderBlockStart: 1,
  borderBlockStartWidth: 1,
  borderBlockWidth: 1,
  borderBottom: 1,
  borderBottomLeftRadius: 1,
  borderBottomRightRadius: 1,
  borderBottomWidth: 1,
  borderEndEndRadius: 1,
  borderEndStartRadius: 1,
  borderInlineEnd: 1,
  borderInlineEndWidth: 1,
  borderInlineStart: 1,
  borderInlineStartWidth: 1,
  borderInlineWidth: 1,
  borderLeft: 1,
  borderLeftWidth: 1,
  borderRadius: 1,
  borderRight: 1,
  borderRightWidth: 1,
  borderSpacing: 1,
  borderStartEndRadius: 1,
  borderStartStartRadius: 1,
  borderTop: 1,
  borderTopLeftRadius: 1,
  borderTopRightRadius: 1,
  borderTopWidth: 1,
  borderWidth: 1,
  bottom: 1,
  columnGap: 1,
  columnRule: 1,
  columnRuleWidth: 1,
  columnWidth: 1,
  containIntrinsicSize: 1,
  flexBasis: 1,
  fontSize: 1,
  gap: 1,
  gridAutoColumns: 1,
  gridAutoRows: 1,
  gridTemplateColumns: 1,
  gridTemplateRows: 1,
  height: 1,
  inlineSize: 1,
  inset: 1,
  insetBlock: 1,
  insetBlockEnd: 1,
  insetBlockStart: 1,
  insetInline: 1,
  insetInlineEnd: 1,
  insetInlineStart: 1,
  left: 1,
  letterSpacing: 1,
  margin: 1,
  marginBlock: 1,
  marginBlockEnd: 1,
  marginBlockStart: 1,
  marginBottom: 1,
  marginInline: 1,
  marginInlineEnd: 1,
  marginInlineStart: 1,
  marginLeft: 1,
  marginRight: 1,
  marginTop: 1,
  maxBlockSize: 1,
  maxHeight: 1,
  maxInlineSize: 1,
  maxWidth: 1,
  minBlockSize: 1,
  minHeight: 1,
  minInlineSize: 1,
  minWidth: 1,
  offsetDistance: 1,
  offsetRotate: 1,
  outline: 1,
  outlineOffset: 1,
  outlineWidth: 1,
  overflowClipMargin: 1,
  padding: 1,
  paddingBlock: 1,
  paddingBlockEnd: 1,
  paddingBlockStart: 1,
  paddingBottom: 1,
  paddingInline: 1,
  paddingInlineEnd: 1,
  paddingInlineStart: 1,
  paddingLeft: 1,
  paddingRight: 1,
  paddingTop: 1,
  perspective: 1,
  right: 1,
  rowGap: 1,
  scrollMargin: 1,
  scrollMarginBlock: 1,
  scrollMarginBlockEnd: 1,
  scrollMarginBlockStart: 1,
  scrollMarginBottom: 1,
  scrollMarginInline: 1,
  scrollMarginInlineEnd: 1,
  scrollMarginInlineStart: 1,
  scrollMarginLeft: 1,
  scrollMarginRight: 1,
  scrollMarginTop: 1,
  scrollPadding: 1,
  scrollPaddingBlock: 1,
  scrollPaddingBlockEnd: 1,
  scrollPaddingBlockStart: 1,
  scrollPaddingBottom: 1,
  scrollPaddingInline: 1,
  scrollPaddingInlineEnd: 1,
  scrollPaddingInlineStart: 1,
  scrollPaddingLeft: 1,
  scrollPaddingRight: 1,
  scrollPaddingTop: 1,
  shapeMargin: 1,
  textDecoration: 1,
  textDecorationThickness: 1,
  textIndent: 1,
  textUnderlineOffset: 1,
  top: 1,
  transitionDelay: 1,
  transitionDuration: 1,
  verticalAlign: 1,
  width: 1,
  wordSpacing: 1
},
    R = function R(e) {
  return String.fromCharCode(e + (e > 25 ? 39 : 97));
},
    z = function z(e) {
  return function (e) {
    var t,
        r = "";

    for (t = Math.abs(e); t > 52; t = t / 52 | 0) {
      r = R(t % 52) + r;
    }

    return R(t % 52) + r;
  }(function (e, t) {
    var r = t.length;

    for (; r;) {
      e = 33 * e ^ t.charCodeAt(--r);
    }

    return e;
  }(5381, JSON.stringify(e)) >>> 0);
},
    W = ["themed", "global", "styled", "onevar", "resonevar", "allvar", "inline"],
    j = function j(e) {
  if (e.href && !e.href.startsWith(location.origin)) return !1;

  try {
    return !!e.cssRules;
  } catch (e) {
    return !1;
  }
},
    E = function E(e) {
  var t;

  var r = function r() {
    var e = t.sheet.cssRules;
    return [].map.call(e, function (r, n) {
      var i = r.cssText;
      var o = "";
      if (i.startsWith("--sxs")) return "";

      if (e[n - 1] && (o = e[n - 1].cssText).startsWith("--sxs")) {
        if (!r.cssRules.length) return "";

        for (var _e3 in t.rules) {
          if (t.rules[_e3].group === r) return "--sxs{--sxs:".concat(_toConsumableArray(t.rules[_e3].cache).join(" "), "}").concat(i);
        }

        return r.cssRules.length ? "".concat(o).concat(i) : "";
      }

      return i;
    }).join("");
  },
      n = function n() {
    if (t) {
      var _t4 = t,
          _e4 = _t4.rules,
          _r = _t4.sheet;

      if (!_r.deleteRule) {
        for (; 3 === Object(Object(_r.cssRules)[0]).type;) {
          _r.cssRules.splice(0, 1);
        }

        _r.cssRules = [];
      }

      for (var _t5 in _e4) {
        delete _e4[_t5];
      }
    }

    var i = Object(e).styleSheets || [];

    var _iterator2 = _createForOfIteratorHelper(i),
        _step2;

    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var _e6 = _step2.value;

        if (j(_e6)) {
          for (var _i3 = 0, _o = _e6.cssRules; _o[_i3]; ++_i3) {
            var _l = Object(_o[_i3]);

            if (1 !== _l.type) continue;

            var _s2 = Object(_o[_i3 + 1]);

            if (4 !== _s2.type) continue;
            ++_i3;
            var _a = _l.cssText;
            if (!_a.startsWith("--sxs")) continue;

            var _c = _a.slice(14, -3).trim().split(/\s+/),
                _d2 = W[_c[0]];

            _d2 && (t || (t = {
              sheet: _e6,
              reset: n,
              rules: {},
              toString: r
            }), t.rules[_d2] = {
              group: _s2,
              index: _i3,
              cache: new Set(_c)
            });
          }

          if (t) break;
        }
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }

    if (!t) {
      var _i2 = function _i2(e, t) {
        return {
          type: t,
          cssRules: [],
          insertRule: function insertRule(e, t) {
            this.cssRules.splice(t, 0, _i2(e, {
              import: 3,
              undefined: 1
            }[(e.toLowerCase().match(/^@([a-z]+)/) || [])[1]] || 4));
          },

          get cssText() {
            return "@media{}" === e ? "@media{".concat([].map.call(this.cssRules, function (e) {
              return e.cssText;
            }).join(""), "}") : e;
          }

        };
      };

      t = {
        sheet: e ? (e.head || e).appendChild(document.createElement("style")).sheet : _i2("", "text/css"),
        rules: {},
        reset: n,
        toString: r
      };
    }

    var _t6 = t,
        o = _t6.sheet,
        l = _t6.rules;

    for (var _e5 = W.length - 1; _e5 >= 0; --_e5) {
      var _t7 = W[_e5];

      if (!l[_t7]) {
        var _r2 = W[_e5 + 1],
            _n3 = l[_r2] ? l[_r2].index : o.cssRules.length;

        o.insertRule("@media{}", _n3), o.insertRule("--sxs{--sxs:".concat(_e5, "}"), _n3), l[_t7] = {
          group: o.cssRules[_n3 + 1],
          index: _n3,
          cache: new Set([_e5])
        };
      }

      v(l[_t7]);
    }
  };

  return n(), t;
},
    v = function v(e) {
  var t = e.group;
  var r = t.cssRules.length;

  e.apply = function (e) {
    try {
      t.insertRule(e, r), ++r;
    } catch (e) {}
  };
},
    T = Symbol(),
    w = o(),
    M = function M(e, t) {
  return w(e, function () {
    return function () {
      var n = {
        type: null,
        composers: new Set()
      };

      for (var _len2 = arguments.length, r = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        r[_key2] = arguments[_key2];
      }

      for (var _i4 = 0, _r3 = r; _i4 < _r3.length; _i4++) {
        var _t8 = _r3[_i4];
        if (null != _t8) if (_t8[l]) {
          null == n.type && (n.type = _t8[l].type);

          var _iterator3 = _createForOfIteratorHelper(_t8[l].composers),
              _step3;

          try {
            for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
              var _e7 = _step3.value;
              n.composers.add(_e7);
            }
          } catch (err) {
            _iterator3.e(err);
          } finally {
            _iterator3.f();
          }
        } else _t8.constructor !== Object || _t8.$$typeof ? null == n.type && (n.type = _t8) : n.composers.add(C(_t8, e));
      }

      return null == n.type && (n.type = "span"), n.composers.size || n.composers.add(["PJLV", {}, [], [], {}, []]), P(e, n, t);
    };
  });
},
    C = function C(_ref3, i) {
  var e = _ref3.variants,
      t = _ref3.compoundVariants,
      r = _ref3.defaultVariants,
      n = _objectWithoutProperties(_ref3, ["variants", "compoundVariants", "defaultVariants"]);

  var o = "".concat(S(i.prefix), "c-").concat(z(n)),
      l = [],
      s = [],
      d = Object.create(null),
      g = [];

  for (var _e8 in r) {
    d[_e8] = String(r[_e8]);
  }

  if ("object" == _typeof(e) && e) for (var _t9 in e) {
    p = d, u = _t9, c.call(p, u) || (d[_t9] = "undefined");
    var _r4 = e[_t9];

    for (var _e9 in _r4) {
      var _n4 = _defineProperty({}, _t9, String(_e9));

      "undefined" === String(_e9) && g.push(_t9);
      var _i5 = _r4[_e9],
          _o2 = [_n4, _i5, !a(_i5)];
      l.push(_o2);
    }
  }
  var p, u;

  if ("object" == _typeof(t) && t) {
    var _iterator4 = _createForOfIteratorHelper(t),
        _step4;

    try {
      for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
        var _e10 = _step4.value;

        var _t10 = _e10.css,
            _r5 = _objectWithoutProperties(_e10, ["css"]);

        _t10 = "object" == _typeof(_t10) && _t10 || {};

        for (var _e11 in _r5) {
          _r5[_e11] = String(_r5[_e11]);
        }

        var _n6 = [_r5, _t10, !a(_t10)];
        s.push(_n6);
      }
    } catch (err) {
      _iterator4.e(err);
    } finally {
      _iterator4.f();
    }
  }

  return [o, n, l, s, d, g];
},
    P = function P(e, t, r) {
  var _s4;

  var _L = L(t.composers),
      _L2 = _slicedToArray(_L, 4),
      n = _L2[0],
      i = _L2[1],
      o = _L2[2],
      a = _L2[3],
      c = "function" == typeof t.type || t.type.$$typeof ? function (e) {
    function t() {
      for (var _r6 = 0; _r6 < t[T].length; _r6++) {
        var _t$T$_r = _slicedToArray(t[T][_r6], 2),
            _n7 = _t$T$_r[0],
            _i6 = _t$T$_r[1];

        e.rules[_n7].apply(_i6);
      }

      return t[T] = [], null;
    }

    return t[T] = [], t.rules = {}, W.forEach(function (e) {
      return t.rules[e] = {
        apply: function apply(r) {
          return t[T].push([e, r]);
        }
      };
    }), t;
  }(r) : null,
      d = (c || r).rules,
      g = ".".concat(n).concat(i.length > 1 ? ":where(.".concat(i.slice(1).join("."), ")") : ""),
      p = function p(l) {
    l = "object" == _typeof(l) && l || A;

    var _l2 = l,
        s = _l2.css,
        p = _objectWithoutProperties(_l2, ["css"]),
        u = {};

    for (var _e12 in o) {
      if (delete p[_e12], _e12 in l) {
        var _t11 = l[_e12];
        "object" == _typeof(_t11) && _t11 ? u[_e12] = _objectSpread({
          "@initial": o[_e12]
        }, _t11) : (_t11 = String(_t11), u[_e12] = "undefined" !== _t11 || a.has(_e12) ? _t11 : o[_e12]);
      } else u[_e12] = o[_e12];
    }

    var h = new Set(_toConsumableArray(i));

    var _iterator5 = _createForOfIteratorHelper(t.composers),
        _step5;

    try {
      for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
        var _ref6 = _step5.value;

        var _ref5 = _slicedToArray(_ref6, 4);

        var _n8 = _ref5[0];
        var _i7 = _ref5[1];
        var _o3 = _ref5[2];
        var _l3 = _ref5[3];
        r.rules.styled.cache.has(_n8) || (r.rules.styled.cache.add(_n8), $(_i7, [".".concat(_n8)], [], e, function (e) {
          d.styled.apply(e);
        }));

        var _t13 = O(_o3, u, e.media),
            _s3 = O(_l3, u, e.media, !0);

        var _iterator7 = _createForOfIteratorHelper(_t13),
            _step7;

        try {
          for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
            var _i8 = _step7.value;

            if (void 0 !== _i8) {
              var _iterator9 = _createForOfIteratorHelper(_i8),
                  _step9;

              try {
                var _loop = function _loop() {
                  var _ref7 = _step9.value;
                  _ref8 = _slicedToArray(_ref7, 3);
                  var t = _ref8[0];
                  var o = _ref8[1];
                  var l = _ref8[2];
                  var i = "".concat(_n8, "-").concat(z(o), "-").concat(t);
                  h.add(i);
                  var s = (l ? r.rules.resonevar : r.rules.onevar).cache,
                      a = l ? d.resonevar : d.onevar;
                  s.has(i) || (s.add(i), $(o, [".".concat(i)], [], e, function (e) {
                    a.apply(e);
                  }));
                };

                for (_iterator9.s(); !(_step9 = _iterator9.n()).done;) {
                  var _ref8;

                  _loop();
                }
              } catch (err) {
                _iterator9.e(err);
              } finally {
                _iterator9.f();
              }
            }
          }
        } catch (err) {
          _iterator7.e(err);
        } finally {
          _iterator7.f();
        }

        var _iterator8 = _createForOfIteratorHelper(_s3),
            _step8;

        try {
          for (_iterator8.s(); !(_step8 = _iterator8.n()).done;) {
            var _t14 = _step8.value;

            if (void 0 !== _t14) {
              var _iterator10 = _createForOfIteratorHelper(_t14),
                  _step10;

              try {
                for (_iterator10.s(); !(_step10 = _iterator10.n()).done;) {
                  var _ref11 = _step10.value;

                  var _ref10 = _slicedToArray(_ref11, 2);

                  var _i9 = _ref10[0];
                  var _o4 = _ref10[1];

                  var _t15 = "".concat(_n8, "-").concat(z(_o4), "-").concat(_i9);

                  h.add(_t15), r.rules.allvar.cache.has(_t15) || (r.rules.allvar.cache.add(_t15), $(_o4, [".".concat(_t15)], [], e, function (e) {
                    d.allvar.apply(e);
                  }));
                }
              } catch (err) {
                _iterator10.e(err);
              } finally {
                _iterator10.f();
              }
            }
          }
        } catch (err) {
          _iterator8.e(err);
        } finally {
          _iterator8.f();
        }
      }
    } catch (err) {
      _iterator5.e(err);
    } finally {
      _iterator5.f();
    }

    if ("object" == _typeof(s) && s) {
      var _t12 = "".concat(n, "-i").concat(z(s), "-css");

      h.add(_t12), r.rules.inline.cache.has(_t12) || (r.rules.inline.cache.add(_t12), $(s, [".".concat(_t12)], [], e, function (e) {
        d.inline.apply(e);
      }));
    }

    var _iterator6 = _createForOfIteratorHelper(String(l.className || "").trim().split(/\s+/)),
        _step6;

    try {
      for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
        var _e13 = _step6.value;
        _e13 && h.add(_e13);
      }
    } catch (err) {
      _iterator6.e(err);
    } finally {
      _iterator6.f();
    }

    var f = p.className = _toConsumableArray(h).join(" ");

    return {
      type: t.type,
      className: f,
      selector: g,
      props: p,
      toString: function toString() {
        return f;
      },
      deferredInjector: c
    };
  };

  return s(p, (_s4 = {
    className: n,
    selector: g
  }, _defineProperty(_s4, l, t), _defineProperty(_s4, "toString", function toString() {
    return r.rules.styled.cache.has(n) || p(), n;
  }), _s4));
},
    L = function L(e) {
  var t = "";
  var r = [],
      n = {},
      i = [];

  var _iterator11 = _createForOfIteratorHelper(e),
      _step11;

  try {
    for (_iterator11.s(); !(_step11 = _iterator11.n()).done;) {
      var _ref14 = _step11.value;

      var _ref13 = _slicedToArray(_ref14, 6);

      var _o5 = _ref13[0];
      var _l4 = _ref13[4];
      var _s5 = _ref13[5];
      "" === t && (t = _o5), r.push(_o5), i.push.apply(i, _toConsumableArray(_s5));

      for (var _e14 in _l4) {
        var _t16 = _l4[_e14];
        (void 0 === n[_e14] || "undefined" !== _t16 || _s5.includes(_t16)) && (n[_e14] = _t16);
      }
    }
  } catch (err) {
    _iterator11.e(err);
  } finally {
    _iterator11.f();
  }

  return [t, r, n, new Set(i)];
},
    O = function O(e, t, r, n) {
  var i = [];

  var _iterator12 = _createForOfIteratorHelper(e),
      _step12;

  try {
    e: for (_iterator12.s(); !(_step12 = _iterator12.n()).done;) {
      var _ref15 = _step12.value;

      var _ref16 = _slicedToArray(_ref15, 3);

      var _o6 = _ref16[0];
      var _l5 = _ref16[1];
      var _s6 = _ref16[2];
      if (_s6) continue;

      var _e15 = void 0,
          _a2 = 0,
          _c2 = !1;

      for (_e15 in _o6) {
        var _n9 = _o6[_e15];
        var _i10 = t[_e15];

        if (_i10 !== _n9) {
          if ("object" != _typeof(_i10) || !_i10) continue e;
          {
            var _e16 = void 0,
                _t17 = void 0,
                _o7 = 0;

            for (var _l6 in _i10) {
              if (_n9 === String(_i10[_l6])) {
                if ("@initial" !== _l6) {
                  var _e17 = _l6.slice(1);

                  (_t17 = _t17 || []).push(_e17 in r ? r[_e17] : _l6.replace(/^@media ?/, "")), _c2 = !0;
                }

                _a2 += _o7, _e16 = !0;
              }

              ++_o7;
            }

            if (_t17 && _t17.length && (_l5 = _defineProperty({}, "@media " + _t17.join(", "), _l5)), !_e16) continue e;
          }
        }
      }

      (i[_a2] = i[_a2] || []).push([n ? "cv" : "".concat(_e15, "-").concat(_o6[_e15]), _l5, _c2]);
    }
  } catch (err) {
    _iterator12.e(err);
  } finally {
    _iterator12.f();
  }

  return i;
},
    A = {},
    N = o(),
    D = function D(e, t) {
  return N(e, function () {
    return function () {
      for (var _len3 = arguments.length, r = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        r[_key3] = arguments[_key3];
      }

      var n = function n() {
        var _iterator13 = _createForOfIteratorHelper(r),
            _step13;

        try {
          for (_iterator13.s(); !(_step13 = _iterator13.n()).done;) {
            var _n10 = _step13.value;
            _n10 = "object" == _typeof(_n10) && _n10 || {};

            var _r7 = z(_n10);

            if (!t.rules.global.cache.has(_r7)) {
              if (t.rules.global.cache.add(_r7), "@import" in _n10) {
                var _e18 = [].indexOf.call(t.sheet.cssRules, t.rules.themed.group) - 1;

                var _iterator14 = _createForOfIteratorHelper([].concat(_n10["@import"])),
                    _step14;

                try {
                  for (_iterator14.s(); !(_step14 = _iterator14.n()).done;) {
                    var _r8 = _step14.value;
                    _r8 = _r8.includes('"') || _r8.includes("'") ? _r8 : "\"".concat(_r8, "\""), t.sheet.insertRule("@import ".concat(_r8, ";"), _e18++);
                  }
                } catch (err) {
                  _iterator14.e(err);
                } finally {
                  _iterator14.f();
                }

                delete _n10["@import"];
              }

              $(_n10, [], [], e, function (e) {
                t.rules.global.apply(e);
              });
            }
          }
        } catch (err) {
          _iterator13.e(err);
        } finally {
          _iterator13.f();
        }

        return "";
      };

      return s(n, {
        toString: n
      });
    };
  });
},
    H = o(),
    V = function V(e, t) {
  return H(e, function () {
    return function (r) {
      var n = "".concat(S(e.prefix), "k-").concat(z(r)),
          i = function i() {
        if (!t.rules.global.cache.has(n)) {
          t.rules.global.cache.add(n);
          var _i11 = [];
          $(r, [], [], e, function (e) {
            return _i11.push(e);
          });

          var _o8 = "@keyframes ".concat(n, "{").concat(_i11.join(""), "}");

          t.rules.global.apply(_o8);
        }

        return n;
      };

      return s(i, {
        get name() {
          return i();
        },

        toString: i
      });
    };
  });
},
    G = /*#__PURE__*/function () {
  function G(e, t, r, n) {
    _classCallCheck(this, G);

    this.token = null == e ? "" : String(e), this.value = null == t ? "" : String(t), this.scale = null == r ? "" : String(r), this.prefix = null == n ? "" : String(n);
  }

  _createClass(G, [{
    key: "toString",
    value: function toString() {
      return this.computedValue;
    }
  }, {
    key: "computedValue",
    get: function get() {
      return "var(" + this.variable + ")";
    }
  }, {
    key: "variable",
    get: function get() {
      return "--" + S(this.prefix) + S(this.scale) + this.token;
    }
  }]);

  return G;
}(),
    F = o(),
    J = function J(e, t) {
  return F(e, function () {
    return function (r, n) {
      n = "object" == _typeof(r) && r || Object(n);
      var i = ".".concat(r = (r = "string" == typeof r ? r : "") || "".concat(S(e.prefix), "t-").concat(z(n))),
          o = {},
          l = [];

      for (var _t18 in n) {
        o[_t18] = {};

        for (var _r9 in n[_t18]) {
          var _i12 = "--".concat(S(e.prefix)).concat(_t18, "-").concat(_r9),
              _s7 = k(String(n[_t18][_r9]), e.prefix, _t18);

          o[_t18][_r9] = new G(_r9, _s7, _t18, e.prefix), l.push("".concat(_i12, ":").concat(_s7));
        }
      }

      var s = function s() {
        if (l.length && !t.rules.themed.cache.has(r)) {
          t.rules.themed.cache.add(r);

          var _i13 = "".concat(n === e.theme ? ":root," : "", ".").concat(r, "{").concat(l.join(";"), "}");

          t.rules.themed.apply(_i13);
        }

        return r;
      };

      return _objectSpread(_objectSpread({}, o), {}, {
        get className() {
          return s();
        },

        selector: i,
        toString: s
      });
    };
  });
},
    U = o();

import Z from "react";

var X,
    Y = o(),
    q = function q(e) {
  var t = function (e) {
    var t = !1;
    var r = U(e, function (e) {
      t = !0;
      var r = "prefix" in (e = "object" == _typeof(e) && e || {}) ? String(e.prefix) : "",
          i = "object" == _typeof(e.media) && e.media || {},
          o = "object" == _typeof(e.root) ? e.root || null : globalThis.document || null,
          l = "object" == _typeof(e.theme) && e.theme || {},
          s = {
        prefix: r,
        media: i,
        theme: l,
        themeMap: "object" == _typeof(e.themeMap) && e.themeMap || _objectSpread({}, n),
        utils: "object" == _typeof(e.utils) && e.utils || {}
      },
          a = E(o),
          c = {
        css: M(s, a),
        globalCss: D(s, a),
        keyframes: V(s, a),
        createTheme: J(s, a),
        reset: function reset() {
          a.reset(), c.theme.toString();
        },
        theme: {},
        sheet: a,
        config: s,
        prefix: r,
        getCssText: a.toString,
        toString: a.toString
      };
      return String(c.theme = c.createTheme(l)), c;
    });
    return t || r.reset(), r;
  }(e);

  return t.styled = function (_ref17) {
    var e = _ref17.config,
        t = _ref17.sheet;
    return Y(e, function () {
      var r = M(e, t);
      return function () {
        var t = r.apply(void 0, arguments),
            n = t[l].type,
            i = Z.forwardRef(function (e, r) {
          var i = e && e.as || n,
              _t19 = t(e),
              o = _t19.props,
              l = _t19.deferredInjector;

          return delete o.as, o.ref = r, l ? Z.createElement(Z.Fragment, null, Z.createElement(i, o), Z.createElement(l, null)) : Z.createElement(i, o);
        });
        return i.className = t.className, i.displayName = "Styled.".concat(n.displayName || n.name || n), i.selector = t.selector, i.toString = function () {
          return t.selector;
        }, i[l] = t[l], i;
      };
    });
  }(t), t;
},
    K = function K() {
  return X || (X = q());
},
    Q = function Q() {
  var _K;

  return (_K = K()).createTheme.apply(_K, arguments);
},
    _ = function _() {
  var _K2;

  return (_K2 = K()).globalCss.apply(_K2, arguments);
},
    ee = function ee() {
  var _K3;

  return (_K3 = K()).keyframes.apply(_K3, arguments);
},
    te = function te() {
  var _K4;

  return (_K4 = K()).css.apply(_K4, arguments);
},
    re = function re() {
  var _K5;

  return (_K5 = K()).styled.apply(_K5, arguments);
};

export { q as createStitches, Q as createTheme, te as css, n as defaultThemeMap, _ as globalCss, ee as keyframes, re as styled }; //# sourceMappingUrl=index.map